<div class="flex items-center justify-end space-x-4">
  <slot />
</div>
